import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_beauty_wellness: FaireCategoryEntity = {
  token: "cat_beauty-wellness",
  type: "category",
  name: "Beauty & wellness",
  level: 1,
  href: "/category/beauty-wellness",
  childCategoryTokens: [
    "cat_beauty-all",
    "cat_beauty-new-products",
    "cat_beauty-new-brands",
    "cat_beauty-bestsellers",
    "cat_beauty-skincare",
    "cat_beauty-fragrance",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
